import { useEffect, useState } from "react";
import moment from "moment";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import { sweetAlertHelper } from "../../../helper/sweetalert.helper";

//formik
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

//element component
import Button from "../../../components/element/button";
import Input from "../../../components/element/input";
import Select from "../../../components/element/select";
import apiServices from "../../../services/api.services";

export default function CreateModalBox({
  title,
  show,
  values,
  close,
  disabled,
  getListing,
}) {
  const [roleList, setRoleList] = useState([]);
  const [genderList, setGenderList] = useState([
    {
      id: "female",
      label: "female",
    },
    {
      id: "male",
      label: "Male",
    },
  ]);

  const [typeList, setTypeList] = useState([
    {
      id: "agent",
      label: "Agent",
    },
    {
      id: "other",
      label: "Other",
    },
  ]);

  const getRoleListing = async () => {
    const response = await apiServices.getRoleListing();
    if (response) {
      setRoleList(response);
    }
  };

  useEffect(() => {
    getRoleListing();
  }, []);

  const [data, setData] = useState({
    name: "",
    last_name: "",
    dob: "",
    gender: "",
    type: "",
    phone_number: "",
    username: "",
    password: "",
    confirm_password: "",
    roles_id: "7",
  });

  const useSchema = Yup.object({
    name: Yup.string().required("required"),
    last_name: Yup.string().required("required"),
    gender: Yup.string().required("required"),
    phone_number: Yup.string()
      .required("required")
      .min(10, "Please enter more than or equal to 10 character")
      .max(13, "Must be exactly 13 digits")
      .matches(/^([6]{1}|\+?[0]{1})([0-9]{9,11})$/g, "Must be phone format"),
    username: Yup.string()
      .required("required")
      .email("Please Enter Correct Email"),
    password: Yup.string().required("required"),
    confirm_password: Yup.string().required("required"),
  });

  const handleSubmit = async (values, setFieldError, setSubmitting) => {
    try {
      const response = await apiServices.createUser({
        payload: values,
        type: "user",
      });
      if (response) {
        sweetAlertHelper({
          title: "Success",
          text: "Create  Success",
          icon: "success",
        });
        close(false);
        getListing();
      }
    } catch (ex) {
      let errorMsg = "";
      setSubmitting(false);
      if (ex && Object.keys(ex).length > 0) {
        if (ex.response.status === 422) {
          const errors = ex.response.data.errors;
          if (errors && Object.keys(errors).length > 0) {
            Object.keys(errors).map((item, i) => {
              errorMsg = errors[item];
              setFieldError(item, errors[item]);
            });
          }
        }
        sweetAlertHelper({
          title: "Error",
          text: `${errorMsg}`,
          icon: "error",
        });
      }
    }
  };

  return (
    <MDBModal staticBackdrop tabIndex="-1" show={show}>
      <MDBModalDialog>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>{title}</MDBModalTitle>
            <MDBBtn
              className="btn-close"
              color="none"
              onClick={() => close((prevState) => !prevState)}
            ></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <Formik
              enableReinitialize={true}
              validateOnChange={true}
              initialValues={data}
              validationSchema={useSchema}
              onSubmit={(
                values,
                { setFieldError, resetForm, setSubmitting }
              ) => {
                handleSubmit(values, setFieldError, setSubmitting);
                // resetForm({ values: ""})
              }}
            >
              {({ handleReset, errors, isSubmitting }) => (
                <Form className="modal-form">
                  <Input label="Username" name="username" type="email" />

                  <Input label="First Name" name="name" />
                  <Input label="Last Name" name="last_name" />
                  <Select
                    name="gender"
                    label="Gender"
                    options={genderList}
                    placeholder="- Please Select -"
                    errors={errors}
                  />
                  <Input label="Phone Number" name="phone_number" />
                  <Input label="Password" name="password" type="password" />
                  <Input
                    label="Confirm Password"
                    name="confirm_password"
                    type="password"
                  />
                  <Select
                    name="type"
                    label="Type"
                    options={typeList}
                    placeholder="- Please Select -"
                    errors={errors}
                  />

                  <Button
                    name="submit"
                    type="submit"
                    isSubmitting={isSubmitting}
                  />
                </Form>
              )}
            </Formik>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
